import { reasonOptionValues } from "library/zendeskAPI/customFieldsMap/closeAccountCustomFieldsMap";

export const reasonOptions = Object.keys(reasonOptionValues).map((label) => ({
  label,
  value: label,
}));
